<template>
	<div class="audit_box animate__animated animate__fadeIn">
		<div class="audit">
			<div class="search_box">
				<div class="box_line">
					<div class="line_input">
					    <div class="input_title">人员姓名</div>
					    <!-- <input type="text" class="input_box" placeholder="请输入人员ID" v-model="searchId"/> -->
					    <el-select size="small" class="select_box" v-model="searchId" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
					        <el-option label="请选择" value></el-option>
					        <el-option v-for="(item,index) in personnelAll" :label="item.name" :value="item.id" :key="index"></el-option>
					    </el-select>
					</div>
					<div class="line_input">
						<div class="input_title">人员状态</div>
						<el-select size="small" class="select_box" v-model="searchStatus" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
							<el-option label="请选择" value></el-option>
							<el-option label="进场待审核" value="0">进场待审核</el-option>
							<el-option label="进场审核不通过" value="1">进场审核不通过</el-option>
							<el-option label="进场审核通过" value="3">进场审核通过</el-option>
							<el-option label="正常退场" value="4">正常退场</el-option>
							<el-option label="强制退场" value="5">强制退场</el-option>
						</el-select>
					</div>
					<div class="line_input">
						<div class="input_title">原因说明</div>
						<input type="text" class="input_box" placeholder="请输入原因说明" v-model="searchExplain" />
					</div>
					<div class="line_input">
						<div class="input_title">创建时间</div>
						<el-date-picker
							size="small"
							v-model="searchCreate_atData"
							type="datetimerange"
							value-format="yyyy-MM-dd HH:mm:ss"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							style="width: 392px;"
						></el-date-picker>
					</div>
					<div class="search_btn" @click="fnSearch"><span>搜索</span></div>
				</div>
			</div>
			<div class="cont_list">
				<div class="list_title">
					<div class="title_item">人员头像</div>
					<div class="title_item">人员姓名</div>
					<div class="title_item">身份证号</div>
					<div class="title_item">性别</div>
					<div class="title_item">所在班组</div>
					<div class="title_item">所属工种</div>
					<div class="title_item">联系电话</div>
					<div class="title_item">创建时间</div>
					<div class="title_item">人员状态</div>
					<div class="title_item">原因说明</div>
					<div class="title_item">操作</div>
				</div>
				<div class="list_boxes">
					<div class="list_box">
						<div v-if="personnelData">
							<div class="box_line" v-for="(item, index) in personnelData" :key="index">
								<div class="list_item"><img :src="item.photo ? item.photo : defaultImg"/></div>
								<div class="list_item">{{ item.name + 1 }}</div>
								<div class="list_item">{{ item.idcard }}</div>
								<div class="list_item">{{ item.sex == '1' ? '男' : '女' }}</div>
								<div class="list_item">{{ letText(item.department) }}</div>
								<div class="list_item">{{ letText(item.position) }}</div>
								<div class="list_item">{{ item.phone }}</div>
								<div class="list_item">{{ item.create_at }}</div>
								<div class="list_item">{{ letStatusText(item.inout_status) }}</div>
								<div :title="item.inout_explain" class="list_item">
									<span>{{ item.inout_explain }}</span>
								</div>
								<div class="list_item">
									<div>
										<button v-if="item.inout_status == 0" class="item_btn yellow" @click="fnGetDetails(item)"><span>审核</span></button>
										<button v-if="item.inout_status == 3" class="item_btn blue" @click="getInout(item)"><span>正常退场</span></button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="cont_page">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="pageSizes"
					:page-size="pageSize"
					:current-page="currentPage"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pageTotal"
				/>
			</div>
			<!-- 原因说明弹窗 -->
			<div class="dialog_reason" v-if="reasonWindow">
				<el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="审核" center :visible.sync="reasonWindow">
					<div class="reason_body">
						<div class="body_item">原因说明</div>
						<div class="body_item"><input type="text" class="input_box" v-model="setData.explain" /></div>
					</div>
					<div slot="footer" class="dialog-footer">
						<div class="btn_line">
							<div class="search_btn" @click="reasonWindow = false"><span>取消</span></div>
							<div class="search_btn blue" @click="fnInout"><span>确 定</span></div>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 查看人员详情 -->
			<div v-if="dialogFormVisible"><AddPerson :editInfo="editInfo" :setData="setData" :path="path"></AddPerson></div>
		</div>
	</div>
</template>
<script>
import { fnRequestPlatform } from '@/utils/upload';
import request from '@/utils/request';
import APP from '@/utils/base';
import { getUserInfo } from '@/utils/auth';
import AddPerson from '../../Person/personCdjg/components/AddPerson';
export default {
	data() {
		return {
			pageSize: APP.PAGE.LIMIT,
			pageSizes: APP.PAGE.SIZE_OPTION,
			currentPage: APP.PAGE.SKIP_PAGE,
			pageTotal: 0,
			searchId: '', // 搜索人员ID
			searchExplain: '', // 搜索原因说明
			searchStatus: '', // 搜索人员状态
			searchCreate_atData: '', // 搜索创建时间
			searchCreate_at: '', // 创建时间的格式化
			defaultImg: 'http://cqxtkj.oss-cn-chengdu.aliyuncs.com/image/40fd31b9434de0d6cc965f1c2b475368.jpg', // 默认头像
			reasonWindow: false, // 原因说明弹窗
			dialogFormVisible: false, // 人员查看详情弹窗
			editInfo: null, // 审核人员信息
			path: 'personnelAudit', // 审核按钮 当前页面路由
			setData: {
				explain: '',
				status: '',
				personnel_id: ''
			},
			personnelData: [] ,// 人员数据
            personnelAll: [],// 所有人员
		};
	},
	components: {
		AddPerson
	},
	created() {
		this.fnInit();
        this.fnGetPerName()
	},
	methods: {
		// 初始化
		fnInit() {
			this.fnGetPersonnel(
				{
					page: this.currentPage,
					size: this.pageSize
				},
				res => {
					this.personnelData = res.data.query;
					this.pageTotal = res.data.count;
				}
			);
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.fnSearch();
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fnSearch();
		},
        // 获取所有人员姓名
        fnGetPerName() {
        	request({
        		url: 'personnel/getAllPersonnel',
        		method: 'GET',
                params: { type : 3 }
        	})
        		.then(res => {
                    this.personnelAll = res.data
        		})
        		.catch(err => {
        			this.$message.error(err.data);
        		});
        },
		// 获取所有人员
		fnGetPersonnel(_obj, _cb) {
			request({
				url: 'inout/getList',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					_cb && _cb(res);
				})
				.catch(err => {
					this.personnelData = []
					this.$message.error('暂无数据');
				});
		},
		// 查看人员详情获取数据 打开弹窗
		fnGetDetails(_data) {
			let _obj = {
				personnel_id: _data.id,
				from: _data.inout_from
			};
			this.setData.personnel_id = _data.id;
            this.setData.status = _data.inout_status;
			request({
				url: 'inout/getDetails',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					this.editInfo = res.data;
					this.dialogFormVisible = !this.dialogFormVisible;
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 关闭 查看人员详情弹窗
		fnOpenAddOrEdit() {
			this.dialogFormVisible = false;
			this.fnInit();
		},
		//确定更改
		fnInout() {
			if (this.setData.explain.length < 4 && this.setData.status != 3) {
				this.$message.error('原因说明长度至少为四个字！');
				return;
			}
			request({
				url: 'inout/set',
				method: 'POST',
				data: this.setData
			})
				.then(res => {
					this.fnSearch();
					this.reasonWindow = false;
					this.$message.success(res.data);
					this.setData.explain = '';
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 正常退场操作  // 审核通过
		getInout(_text) {
			if (_text.status == 0 && _text.personnel_id) {
				this.setData.personnel_id = _text.personnel_id;
				//审核通过
				this.setData.status = 3;
				this.fnInout();
				return;
			}
			if (_text.inout_status == 3) {
				this.setData.personnel_id = _text.id;
				this.setData.status = 4;
				//正常退场
				this.reasonWindow = true;
				return;
			}
			this.$message.error('状态异常');
		},

		// 操作未通过
		getNoInout(_text) {
			this.setData.personnel_id = _text.personnel_id;
			this.setData.status = 1;
			this.setData.explain = '';
			this.reasonWindow = true;
		},
		//搜索
		fnSearch() {
			if (this.searchCreate_atData != '') {
				this.searchCreate_at = this.searchCreate_atData[0] + ',' + this.searchCreate_atData[1];
			} else {
				this.searchCreate_at = '';
			}
			this.fnGetPersonnel(
				{
					page: this.currentPage,
					size: this.pageSize,
					personnel_id: this.searchId,
					status: this.searchStatus,
					explain: this.searchExplain,
					create_at: this.searchCreate_at
				},
				res => {
					this.personnelData = res.data.query;
					this.searchCreate_atData = '';
					this.pageTotal = res.data.count;
				}
			);
		},
		//班组工种格式化
		letText(_text) {
			return APP.fnTeamFormat(_text);
		},
		//人员状态格式化
		letStatusText(_status) {
			switch (_status) {
				case 0:
					return '进场待审核';
				case 1:
					return '审核未通过';
				case 2:
					return '取消进场审核';
				case 3:
					return '审核通过';
				case 4:
					return '已退场';
				case 5:
					return '已强制退场';
				default:
					break;
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import '~@/styles/view/personnelAudit.scss';
</style>



// WEBPACK FOOTER //
// src/views/PersonnelAudit/personnelAuditCdjg/index.vue